import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

type CmsContent = Record<string, string>;

const normalize = (val: any): string => {
  if (val === null || val === undefined) return "";
  let s = typeof val === "string" ? val : String(val);
  // Unwrap accidental double/triple JSON encoding from legacy data.
  for (let i = 0; i < 3; i++) {
    if (s.length >= 2 && s.startsWith('"') && s.endsWith('"')) {
      try { const p = JSON.parse(s); if (typeof p === "string") { s = p; continue; } } catch {}
    }
    break;
  }
  return s;
};

export const useCmsContent = () => {
  const [content, setContent] = useState<CmsContent>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from("app_settings")
      .select("key, value")
      .then(({ data }) => {
        const map: CmsContent = {};
        (data || []).forEach((row: any) => {
          map[row.key] = normalize(row.value);
        });
        setContent(map);
        setLoading(false);
      });
  }, []);

  return { content, loading };
};
